export default {
  dev: {
    key: '4wy6ihHaQctSXbilFQ/GH7cKAXl1IsAb',
    iv: 'A000000000000024',
    pid: '2dea30ae'
  },
  pro: {
    key: '+tf1D9WwjUDi90gZ4230bLIQFWBR+hFA',
    iv: 'A000000000000123',
    pid: '3d5265eb'
  }
}
